/* IZI: extend the shared frame to standalone content photos (rich text,
   custom page blocks, and asynchronously added page images).
   Never wraps/moves elements, changes a source, fetches data, or handles cart
   events. Native galleries use CSS so their zoom / swipe DOM stays intact. */
(() => {
  'use strict';
  if (!document.body.classList.contains('izi-framed-theme') || window.__iziPhotoFrames) return;
  window.__iziPhotoFrames = true;
  const root = document.getElementById('MainContent');
  if (!root) return;

  const excluded = [
    '[data-izi-no-frame]', '.logo-block', '.header-logo', '.icon-block',
    '.svg-wrapper', '.icon', '.payment-icons', '.payment-types',
    '.shopify-payment-button', '.localization-form', '.swatch',
    '.variant-option__button-label--has-swatch', '.variant-option--swatches',
    '.dialog-zoomed-gallery', 'product-model', 'deferred-media',
    '.product-card__content', '.collection-card', '.featured-blog-posts-card',
    '.blog-post-card', '.resource-card', '.card-gallery', 'media-gallery',
    '.hero__container', '.hero__blurred-image', '.background-image-container',
    '.image-block', '.media-block', '.blog-post-featured-image',
    '.izi-creator', '.izi-atelier', '.izi-category-tile', '.izi-b-product',
    '.izi-story-card', '.izi-editorial-hero__media',
    "[class^='ai-collection-banner-']:has(> img)"
  ].join(',');
  const skipName = /(?:^|[\s/_-])(?:logo|icon|favicon|flag|swatch|payment|visa|mastercard|applepay|googlepay|tabby)(?:[\s/_.-]|$)/i;

  function frame(img) {
    if (!(img instanceof HTMLImageElement) || img.closest(excluded)) return;
    if (img.classList.contains('izi-standalone-image-frame')) return;
    const src = img.currentSrc || img.getAttribute('src') || '';
    if (/^data:image\/svg|\.svg(?:[?#]|$)/i.test(src)) return;
    if (skipName.test(`${img.className} ${img.alt} ${src.split('/').pop() || ''}`)) return;
    const box = img.getBoundingClientRect();
    const width = box.width || Number(img.getAttribute('width')) || img.naturalWidth;
    const height = box.height || Number(img.getAttribute('height')) || img.naturalHeight;
    if (width < 100 || height < 90) return; // exclude small interface marks
    img.classList.add('izi-standalone-image-frame');
  }
  function scan(node) {
    if (!(node instanceof Element)) return;
    if (node.matches('img')) frame(node);
    node.querySelectorAll('img').forEach(frame);
  }

  scan(root);
  // A lazy-loaded photo may have no dimensions during the first pass.
  root.addEventListener('load', event => frame(event.target), true);
  let scheduled = false;
  const pending = new Set();
  const observer = new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) if (node instanceof Element) pending.add(node);
    }
    if (!pending.size || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      for (const node of pending) if (root.contains(node)) scan(node);
      pending.clear();
    });
  });
  observer.observe(root, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
